import { createContext } from 'svelte'
import type { Person } from '@tadpoles/common'

export class MyAccountReturnState {
    #pathname = $state.raw<string | undefined>(undefined)
    #personKey = $state.raw<Person['key'] | undefined>(undefined)

    public setPerson(personKey: Person['key']): void {
        if (this.#personKey === personKey) {
            return
        }

        this.#personKey = personKey
        this.#pathname = undefined
    }

    public capture(personKey: Person['key'], pathname: string): void {
        this.setPerson(personKey)
        this.#pathname = pathname
    }

    public getPathname(personKey: Person['key']): string | undefined {
        return this.#personKey === personKey ? this.#pathname : undefined
    }

    public clear(personKey?: Person['key']): void {
        if (personKey !== undefined && this.#personKey !== personKey) {
            return
        }

        this.#pathname = undefined
        this.#personKey = personKey
    }
}

export const [getMyAccountReturnState, setMyAccountReturnState] =
    createContext<MyAccountReturnState>()
